export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14071.0b77fbf9.jpg";